import React, { memo } from 'react';

const VideoElement = memo(
  ({
    src,
    isVisible,
    index,
    onCanPlay,
    onLoadStart,
    onError,
    onLoadedMetadata,
    onEnded,
    onSeeked,
    onTimeUpdate,
    style,
    fallbackImage,
    ...props
  }) => (
    <video
      {...props}
      src={isVisible ? src : undefined}
      onCanPlay={onCanPlay}
      onLoadStart={onLoadStart}
      onError={onError}
      onLoadedMetadata={onLoadedMetadata}
      onEnded={onEnded}
      onSeeked={onSeeked}
      onTimeUpdate={onTimeUpdate}
      style={{
        transition: 'opacity 0.5s ease-in-out',
        ...style,
      }}
      className="absolute inset-0 w-full h-full object-cover transition-opacity duration-1000"
      poster={fallbackImage}
    />
  )
);

VideoElement.displayName = 'VideoElement';

export default VideoElement;
